import { initialize as initCharacters } from './characters';
import { register as registerHeightComponent } from './heightComponent';

export default function initialize() {
	registerHeightComponent();
	initCharacters();
}



// WEBPACK FOOTER //
// ./~/@dojo/cli-build-webpack/loaders/css-module-dts-loader?type=ts&instanceName=0_dojo!./src/definitions/initialize.ts